<div class="ai-alert" *ngIf="showAlert" @fadeSlide>
  <span class="icon" *ngIf="showIcon"><img src="assets/images/stars.svg"/></span>
  <span class="message">
    {{ message }}
  </span>
  <button class="close-btn" (click)="closeAlert()">×</button>
</div>
